import useUserStore from '../../redux/utils/storeUtils';

const Jurisdiction = () => {
	const { selectedClerk } = useUserStore();

	return (
		<b>
			{selectedClerk.countyCodeDescription} {selectedClerk.clerkTypeDescription}
		</b>
	);
};

export default Jurisdiction;
